import axios from "axios";

import session from "./session";

import envConfig from "@/config/env.config";

const serverUrl = envConfig.ROOT_API;

// import EspressoAux from '@/components/Espresso/EspressoAux.vue';

const requestErrorHandler = async (error) => {
	console.error(error);

	// if (error.message === 'Network Error') {
	// 	await EspressoAux.showFailModal('Verifique sua conexão com a internet', 'Falha de conexão');
	// 	throw Error('API_CONNECTION_ERROR');
	// }

	switch (error.response.status) {
	case 401:
		session.clear();
		// @ts-ignore
		window.vueRouter.push("/login");
		return;
	case 403:
		throw Error("API_FORBIDDEN"); // user does not have correct privileges
	case 404:
		throw Error("API_NOT_FOUND");
	case 429:
		throw Error("API_RATE_LIMIT");
	case 500:
		throw Error("API_SERVER_ERROR");
	default:
		throw error.response.data;
	}
};

export default {
	async send(apiName, command, data, sendToken = false) {
		try {
			const response = await axios.request({
				url: `${serverUrl}/${apiName}/${command}`,
				method: "post",
				headers: {
					Authorization: sendToken ? `Bearer ${session.getItem("token")}` : "",
				},
				data,
			});
			if (response.data) {
				return response.data;
			}
			throw Error("API_DATA_NOT_FOUND");
		} catch (error) {
			return requestErrorHandler(error);
		}
	},
	async uploadFile(file: any) {
		const formData = new FormData();
		formData.append("file", file);
		try {
			const response = await axios.request({
				url: "https://upload.soniprev.com/",
				method: "post",
				data: formData,
			});
			if (response.data) {
				return response.data;
			}
			throw Error("API_DATA_NOT_FOUND");
		} catch (error) {
			return requestErrorHandler(error);
		}
	},
};
